import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { humpclub, RequestOptions } from '../utils/backend'

export const useBirthdayGameStatus = () => {
  let { isFetching, error, data } = useQuery<string, [string, RequestOptions<any>?]>(
    [`/games/birthday/status`],
    humpclub,
  )

  return { isFetching, error, slug: data }
}

export const useGamesStatus = () => {
  let { isFetching, error, data } = useQuery<boolean, [string, RequestOptions<any>?]>(
    [`/games/status`],
    humpclub,
  )

  return { isFetching, error, isActive: data }
}
